export default "__VITE_ASSET___PGGBM4n__"